import 'rc-pagination/dist/rc-pagination.min.css';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getRankApps } from '../../actions/topn';
import ALineCard from '../../components/ALineCard/ALineCard';
import LineCard from '../../components/LineCard/LineCard';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import Loading from '../../components/Loading/Loading';
import styles from './TopnMore.module.less';
import InfiniteScroll from '../../components/InfinteScroll/GridInfinteScroll';
import KeepAlive, { useActivate } from 'react-activation';

const selectSearchRecommend = createSelector(
  state => state.search,
  search => search.searchRecommend,
);
const selectRankApps = createSelector(
  state => state.topn,
  topn => topn.rankApps,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(props => {
  const dispatch = useDispatch();
  const rankAppsData = useSelector(selectRankApps);
  const searchRecommend = useSelector(selectSearchRecommend);
  const logInfoData = useSelector(selectLogInfo);
  const { match } = props;

  // const [currentPage, setCurrentPage] = useState(1);
  // const [total, setTotal] = useState(0);
  // const pageSize = 12;
  // const [isChange, setIsChange] = useState(false);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Rank_More_Page||${match.params.code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            code: match.params.code,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    // 排行更多页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Rank_More_Page',
        label: '',
        param2: {
          source: `Rank_More_Page||${match.params.code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Rank_More_Page||${match.params.code}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);
  useEffect(() => {
    dispatch(
      getRankApps({
        skip: 0,
        limit: 12,
        code: match.params.code || '',
        refresh: true,
      }),
    );
  }, []);
  useActivate(() => {
    dispatch(
      getRankApps({
        skip: 0,
        limit: 12,
        code: match.params.code || '',
        refresh: true,
      }),
    );
  });

  const loadMore = () => {
    if (!rankAppsData.loading && rankAppsData.apps.length < rankAppsData.pagenation.count) {
      dispatch(
        getRankApps({
          skip: rankAppsData.apps.length,
          limit: 12,
          code: match.params.code || '',
          refresh: false,
        }),
      );
      // // 猜你喜欢 切换页面打桩
      // dispatch(
      //   logging({
      //     category: 'C',
      //     action: 'Paging',
      //     label: '',
      //     param2: {
      //       source: `RankMorePage||${rankAppsData.code}`,
      //       source_p: logInfoData.source_p,
      //       source_pp: logInfoData.source_pp,
      //       // pagenum: pageIndex,
      //     },
      //   }),
      // );
    }
  };

  if (
    !(
      rankAppsData &&
      rankAppsData.apps &&
      rankAppsData.apps.length > 0 &&
      rankAppsData.code === match.params.code
    )
  ) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <KeepAlive>
      <div className={styles.recommend_guess_likes}>
        {/* <div className={styles.recommend_header}>
          <div className={styles.recommend_header_title}>
            {rankAppsData.desc || match.params.title}
          </div>
        </div> */}
        <div className={styles.app_cards}>
          <InfiniteScroll
            dataSource={[...rankAppsData.apps]} // 数据集
            count={rankAppsData.pagenation.count}
            minimumBatchSize={10} // 一行最多统一时间加载个数 默认10
            threshold={10} // 预加载个数
            getItemSize={index => {
              const soft = rankAppsData.apps[index];
              if (
                soft &&
                soft.androidType === '1' &&
                searchRecommend[soft.packageName] &&
                searchRecommend[soft.packageName].apps &&
                searchRecommend[soft.packageName].apps.length > 4
              ) {
                return 210 + (index === 0 ? 44 : 0);
              }
              if (
                soft &&
                soft.androidType !== '1' &&
                searchRecommend[soft.softID] &&
                searchRecommend[soft.softID].apps &&
                searchRecommend[soft.softID].apps.length > 4
              ) {
                return 210 + (index === 0 ? 44 : 0);
              }
              return 100 + (index === 0 ? 44 : 0);
            }} // 行高
            loadData={loadMore}
            column={1}
            template={(soft, i) => {
              return (
                <div className={styles.app}>
                  {soft.androidType === '1' ? (
                    <React.Fragment key={i}>
                      <ALineCard
                        logInfo={{ source: `Rank_More_Page||${match.params.code}` }}
                        soft={soft}
                        key={i}
                      />
                      {searchRecommend[soft.packageName] &&
                        searchRecommend[soft.packageName].apps &&
                        searchRecommend[soft.packageName].apps.length > 4 && (
                          <LineCardDReco
                            recommendData={searchRecommend[soft.packageName]}
                            logInfo={{
                              source: `Rank_More_Page||${match.params.code}||DReco||${soft.packageName}`,
                              source_p: logInfoData.source_p,
                              source_pp: logInfoData.source_pp,
                            }}
                          />
                        )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={i}>
                      <LineCard
                        logInfo={{ source: `Rank_More_Page||${match.params.code}` }}
                        soft={soft}
                      />
                      {searchRecommend[soft.softID] &&
                        searchRecommend[soft.softID].apps &&
                        searchRecommend[soft.softID].apps.length > 4 && (
                          <LineCardDReco
                            recommendData={searchRecommend[soft.softID]}
                            logInfo={{
                              source: `Rank_More_Page||${match.params.code}||DReco||${soft.softID}`,
                              source_p: logInfoData.source_p,
                              source_pp: logInfoData.source_pp,
                            }}
                          />
                        )}
                    </React.Fragment>
                  )}
                </div>
              );
            }}
            tpl={() => (
              <div className={styles.recommend_header}>
                <div className={styles.recommend_header_title}>
                  {rankAppsData.desc || match.params.title}
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </KeepAlive>
  );
});
